import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Button from 'react-bootstrap/Button';
import CollapsedPanel from '../../../components/CollapsedPanel';

function SettingsSidebar({ settingsSidebar, collapsed, expandSidebar }) {
  const params = useParams();
  const navigate = useNavigate();

  const [openedAccordions, setOpenedAccordions] = useState([]);

  if (collapsed) {
    return <CollapsedPanel side="right" onClick={expandSidebar} />;
  }

  return (
    <div className="d-flex flex-column">
      <div className="mt-3 mb-3">
        <h2 className="mx-4">Settings</h2>
        <div className="mt-4 d-flex flex-column">
          {Object.entries(settingsSidebar).map(([key, value]) => {
            if (value.nested) {
              return (
                <div key={key}>
                  <Button
                    className="bo-sidebar-accordion"
                    onClick={() =>
                      setOpenedAccordions(prev =>
                        prev.includes(key) ? prev.filter(x => x !== key) : [...prev, key],
                      )
                    }
                    disabled={value.disabled}
                  >
                    <div className="bo-sidebar-accordion-icon">
                      <FontAwesomeIcon
                        icon={openedAccordions.includes(key) ? faAngleDown : faAngleRight}
                        size="lg"
                      />
                    </div>
                    <p className="p-0 m-0">{value.name}</p>
                  </Button>
                  {openedAccordions.includes(key) && (
                    <div className="w-100">
                      {Object.entries(value.nested).map(([nKey, nValue]) => (
                        <Button
                          key={nKey}
                          className={classNames(
                            'bo-sidebar-button fw-normal',
                            params?.tab === nKey && 'bo-sidebar-button-active',
                          )}
                          onClick={() => navigate(`/settings/${nKey}`)}
                          disabled={nValue.disabled}
                        >
                          <p className="p-0 m-0 ps-3">{nValue.name}</p>
                        </Button>
                      ))}
                    </div>
                  )}
                </div>
              );
            }

            return (
              <Button
                key={key}
                className={classNames(
                  'bo-sidebar-button',
                  params?.tab === key && 'bo-sidebar-button-active',
                )}
                onClick={() => navigate(`/settings/${key}`)}
                disabled={value.disabled}
              >
                <p className="p-0 m-0"> {value.name}</p>
              </Button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default SettingsSidebar;
